<script setup lang="ts">
import { ref, watch} from "vue"
import i18n from '@/lang/i18n';

type Props = {
  title: string
  dialogState: boolean
  actionKey: string
  confirmText: string
  modalMaxWidth?: string
  execBtnName?: string
  btnClass?: string
  closeBtnName?: string
  closeBtnClass?: string
  isLoading: boolean
  message?: string
  disabled?: boolean
  resultMessageColor: string
}

const emits = defineEmits(['closeModal', 'exec'])

const props = withDefaults(defineProps<Props>(), {
  dialogState: false,
  modalMaxWidth: '50%',
  execBtnName: i18n.global.t('pages.common.button.exec'),
  closeBtnName: i18n.global.t('pages.common.button.close'),
})

const state = ref<boolean>(false)

function close() {
  state.value = false
  emits("closeModal", props.disabled)
}

watch(() => props.dialogState, (value: boolean) => {
    state.value = value
    if (state.value) return
  }
)
</script>
<template>
  <v-dialog
    v-model="state"
    width="25%"
    :max-width="modalMaxWidth"
    persistent
  >
    <v-card
      style="background-color: white"
    >
      <v-card-title class="modal-header d-flex justify-content-center mt-2">
        {{ props.title }}
      </v-card-title>

      <v-card-text class="modal-body p-0">
        <div class="text-center mt-2">{{ props.confirmText }}</div>
        <div class="text-center mt-2" :style="{color: props.resultMessageColor}">{{ props.message }}</div>
        <div class="d-flex justify-content-end m-3 mt-4">
          <v-btn
            class="close-btn"
            :class="closeBtnClass"
            :disabled="props.isLoading"
            @click="close"
          >
            {{ props.closeBtnName }}
          </v-btn>

          <v-btn
            class="exec-btn ml-2"
            :class="props.btnClass"
            :style="{ backgroundColor: props.disabled ? 'rgb(179, 184, 187)' : '', }"
            :disabled="props.disabled"
            :loading="props.isLoading"
            @click="emits('exec')"
          >
            {{ props.execBtnName }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
